// Apple 스타일 토스트 알림 + 전 페이지 alert() 대체.
// 화면 중앙에 카드만 뜸(배경 안 어둡게, 뒤 페이지 클릭 통과). 클릭/자동 사라짐.

function pickType(msg) {
  const m = String(msg || "");
  if (/(실패|오류|에러|error|fail|denied|거부|초과|불가)/i.test(m)) return "error";
  if (/(완료|성공|저장|등록|삭제|적용|변경|발송|전송)/.test(m)) return "success";
  return "info";
}

// 애플 시스템 컬러
const THEME = {
  success: { icon: "✓", accent: "#34C759" },
  error: { icon: "✕", accent: "#FF3B30" },
  info: { icon: "i", accent: "#007AFF" },
};

const APPLE_FONT =
  "-apple-system, BlinkMacSystemFont, 'SF Pro Display', 'SF Pro Text', 'Apple SD Gothic Neo', 'Malgun Gothic', 'Segoe UI', system-ui, sans-serif";

export function showToast(message, type) {
  if (typeof document === "undefined") return;
  const msg = String(message == null ? "" : message);
  if (!msg.trim()) return;

  const t = THEME[type || pickType(msg)] || THEME.info;

  // 화면 중앙 정렬용 컨테이너 — 배경 없음, 클릭은 뒤로 통과(pointer-events:none)
  const overlay = document.createElement("div");
  overlay.style.cssText = [
    "position:fixed",
    "inset:0",
    "z-index:2147483647",
    "display:flex",
    "align-items:center",
    "justify-content:center",
    "padding:20px",
    "pointer-events:none",
  ].join(";");

  const el = document.createElement("div");
  el.style.cssText = [
    "pointer-events:auto",
    "min-width:240px",
    "max-width:360px",
    "background:rgba(250,250,252,0.82)",
    "backdrop-filter:blur(22px) saturate(180%)",
    "-webkit-backdrop-filter:blur(22px) saturate(180%)",
    "border:0.5px solid rgba(255,255,255,0.6)",
    "border-radius:22px",
    "box-shadow:0 12px 50px rgba(0,0,0,0.22)",
    "padding:26px 28px",
    "display:flex",
    "flex-direction:column",
    "align-items:center",
    "text-align:center",
    "gap:14px",
    "font-family:" + APPLE_FONT,
    "opacity:0",
    "transform:scale(0.88)",
    "transition:opacity .28s ease, transform .34s cubic-bezier(0.34,1.56,0.64,1)",
    "word-break:break-word",
  ].join(";");

  const badge = document.createElement("div");
  badge.textContent = t.icon;
  badge.style.cssText = [
    "width:52px",
    "height:52px",
    "border-radius:50%",
    "background:" + t.accent,
    "color:#fff",
    "font-weight:600",
    "font-size:27px",
    "line-height:1",
    "display:flex",
    "align-items:center",
    "justify-content:center",
    "box-shadow:0 4px 14px " + t.accent + "40",
  ].join(";");

  const text = document.createElement("div");
  text.textContent = msg;
  text.style.cssText =
    "font-size:16px;font-weight:600;line-height:1.45;letter-spacing:-0.01em;color:#1d1d1f;";

  el.appendChild(badge);
  el.appendChild(text);
  overlay.appendChild(el);
  document.body.appendChild(overlay);

  requestAnimationFrame(() => {
    el.style.opacity = "1";
    el.style.transform = "scale(1)";
  });

  const life = Math.min(3000, Math.max(1500, msg.length * 55));
  let done = false;
  const remove = () => {
    if (done) return;
    done = true;
    el.style.opacity = "0";
    el.style.transform = "scale(0.92)";
    setTimeout(() => {
      try {
        document.body.removeChild(overlay);
      } catch (e) {}
    }, 280);
  };

  const timer = setTimeout(remove, life);
  el.addEventListener("click", () => {
    clearTimeout(timer);
    remove();
  });
}

// 전 페이지의 alert()를 토스트로 대체 (앱 시작 시 1회 호출)
export function installToastAlert() {
  if (typeof window === "undefined") return;
  if (window.__toastAlertInstalled) return;
  window.__toastAlertInstalled = true;
  window.alert = function (msg) {
    showToast(msg);
  };
}

// ---------- 확인/입력 모달 (window.confirm / window.prompt 대체) ----------
// 애플 스타일 모달. Promise 반환:
//   confirmDialog(...) → Promise<boolean>
//   promptDialog(...)  → Promise<string|null>

const DIALOG_CARD_CSS = [
  "pointer-events:auto",
  "width:min(92vw,380px)",
  "background:rgba(250,250,252,0.92)",
  "backdrop-filter:blur(22px) saturate(180%)",
  "-webkit-backdrop-filter:blur(22px) saturate(180%)",
  "border:0.5px solid rgba(255,255,255,0.6)",
  "border-radius:22px",
  "box-shadow:0 18px 60px rgba(0,0,0,0.30)",
  "padding:24px 24px 18px",
  "display:flex",
  "flex-direction:column",
  "gap:8px",
  "font-family:" + APPLE_FONT,
  "opacity:0",
  "transform:scale(0.9)",
  "transition:opacity .24s ease, transform .3s cubic-bezier(0.34,1.56,0.64,1)",
].join(";");

function buildOverlay() {
  const overlay = document.createElement("div");
  overlay.style.cssText = [
    "position:fixed",
    "inset:0",
    "z-index:2147483647",
    "display:flex",
    "align-items:center",
    "justify-content:center",
    "padding:20px",
    "background:rgba(0,0,0,0.32)",
    "backdrop-filter:blur(2px)",
    "-webkit-backdrop-filter:blur(2px)",
    "opacity:0",
    "transition:opacity .2s ease",
  ].join(";");
  return overlay;
}

function mkButton(label, kind) {
  const b = document.createElement("button");
  b.type = "button";
  b.textContent = label;
  const base =
    "flex:1;padding:11px 14px;border-radius:13px;font-size:15px;font-weight:600;cursor:pointer;border:none;transition:filter .15s ease;letter-spacing:-0.01em;";
  const styles = {
    primary: "background:#007AFF;color:#fff;",
    danger: "background:#FF3B30;color:#fff;",
    cancel: "background:rgba(120,120,128,0.16);color:#1d1d1f;",
  };
  b.style.cssText = base + (styles[kind] || styles.primary);
  b.onmouseenter = () => (b.style.filter = "brightness(0.94)");
  b.onmouseleave = () => (b.style.filter = "none");
  return b;
}

export function confirmDialog(message, opts) {
  const o = opts || {};
  return new Promise((resolve) => {
    if (typeof document === "undefined") return resolve(false);
    const overlay = buildOverlay();
    const card = document.createElement("div");
    card.style.cssText = DIALOG_CARD_CSS;

    if (o.title) {
      const title = document.createElement("div");
      title.textContent = o.title;
      title.style.cssText =
        "font-size:17px;font-weight:700;color:#1d1d1f;letter-spacing:-0.02em;";
      card.appendChild(title);
    }
    const msg = document.createElement("div");
    msg.textContent = String(message == null ? "" : message);
    msg.style.cssText =
      "font-size:14.5px;font-weight:500;line-height:1.5;color:#3a3a3c;white-space:pre-line;margin-bottom:8px;";
    card.appendChild(msg);

    const row = document.createElement("div");
    row.style.cssText = "display:flex;gap:10px;margin-top:4px;";
    const cancelBtn = mkButton(o.cancelText || "취소", "cancel");
    const okBtn = mkButton(o.confirmText || "확인", o.danger ? "danger" : "primary");
    row.appendChild(cancelBtn);
    row.appendChild(okBtn);
    card.appendChild(row);
    overlay.appendChild(card);
    document.body.appendChild(overlay);

    requestAnimationFrame(() => {
      overlay.style.opacity = "1";
      card.style.opacity = "1";
      card.style.transform = "scale(1)";
    });

    let done = false;
    const close = (result) => {
      if (done) return;
      done = true;
      document.removeEventListener("keydown", onKey);
      overlay.style.opacity = "0";
      card.style.opacity = "0";
      card.style.transform = "scale(0.94)";
      setTimeout(() => {
        try {
          document.body.removeChild(overlay);
        } catch (e) {}
      }, 220);
      resolve(result);
    };
    const onKey = (e) => {
      if (e.key === "Escape") close(false);
      else if (e.key === "Enter") close(true);
    };
    document.addEventListener("keydown", onKey);
    cancelBtn.onclick = () => close(false);
    okBtn.onclick = () => close(true);
    overlay.onclick = (e) => {
      if (e.target === overlay) close(false);
    };
    setTimeout(() => okBtn.focus(), 60);
  });
}

export function promptDialog(message, defaultValue, opts) {
  const o = opts || {};
  return new Promise((resolve) => {
    if (typeof document === "undefined") return resolve(null);
    const overlay = buildOverlay();
    const card = document.createElement("div");
    card.style.cssText = DIALOG_CARD_CSS;

    if (o.title) {
      const title = document.createElement("div");
      title.textContent = o.title;
      title.style.cssText =
        "font-size:17px;font-weight:700;color:#1d1d1f;letter-spacing:-0.02em;";
      card.appendChild(title);
    }
    const msg = document.createElement("div");
    msg.textContent = String(message == null ? "" : message);
    msg.style.cssText =
      "font-size:14.5px;font-weight:500;line-height:1.5;color:#3a3a3c;white-space:pre-line;";
    card.appendChild(msg);

    const input = document.createElement("input");
    input.type = o.inputType || "text";
    input.value = defaultValue == null ? "" : String(defaultValue);
    input.style.cssText =
      "margin:10px 0 4px;padding:11px 13px;border-radius:12px;border:1px solid rgba(120,120,128,0.28);background:#fff;font-size:15px;color:#1d1d1f;outline:none;font-family:" +
      APPLE_FONT +
      ";";
    input.onfocus = () => (input.style.border = "1.5px solid #007AFF");
    input.onblur = () => (input.style.border = "1px solid rgba(120,120,128,0.28)");
    card.appendChild(input);

    const row = document.createElement("div");
    row.style.cssText = "display:flex;gap:10px;margin-top:8px;";
    const cancelBtn = mkButton(o.cancelText || "취소", "cancel");
    const okBtn = mkButton(o.confirmText || "확인", "primary");
    row.appendChild(cancelBtn);
    row.appendChild(okBtn);
    card.appendChild(row);
    overlay.appendChild(card);
    document.body.appendChild(overlay);

    requestAnimationFrame(() => {
      overlay.style.opacity = "1";
      card.style.opacity = "1";
      card.style.transform = "scale(1)";
    });

    let done = false;
    const close = (result) => {
      if (done) return;
      done = true;
      document.removeEventListener("keydown", onKey);
      overlay.style.opacity = "0";
      card.style.opacity = "0";
      card.style.transform = "scale(0.94)";
      setTimeout(() => {
        try {
          document.body.removeChild(overlay);
        } catch (e) {}
      }, 220);
      resolve(result);
    };
    const onKey = (e) => {
      if (e.key === "Escape") close(null);
      else if (e.key === "Enter") close(input.value);
    };
    document.addEventListener("keydown", onKey);
    cancelBtn.onclick = () => close(null);
    okBtn.onclick = () => close(input.value);
    overlay.onclick = (e) => {
      if (e.target === overlay) close(null);
    };
    setTimeout(() => {
      input.focus();
      input.select();
    }, 60);
  });
}
